import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import ListSubheader from '@mui/material/ListSubheader'
import MenuItem from '@mui/material/MenuItem'
import MenuList from '@mui/material/MenuList'
import ChatWithSupportIcon from '@mui/icons-material/ChatBubbleOutline'
import HelpCentreIcon from '@mui/icons-material/HelpOutline'
import LoadedAcademyIcon from '@mui/icons-material/SchoolOutlined'
import PrivacyPolicyIcon from '@mui/icons-material/PrivacyTipOutlined'
import EulaIcon from '@mui/icons-material/BookmarksOutlined'

/**
 * Static links to things not environment specific.
 */
const HELP_CENTRE_URL = 'https://www.loadedhub.com/knowledge-base'
const LOADED_ACADEMY_URL = 'https://www.loadedhub.com/academy'
const PRIVACY_POLICY_URL = 'https://www.loadedhub.com/loaded-privacy-policy'
const EULA_URL = 'https://www.loadedhub.com/loaded-terms-of-use'

type HelpSectionProps = {
  readonly onClose: () => void
  readonly onChatWithSupport: () => void
}

/**
 * Help-scoped actions: the help centre, chat with support (opens Intercom),
 * and the static privacy policy / terms of use links. The external links close
 * the flyout on click so it isn't left open behind the new tab. (Invite Support
 * intentionally dropped.)
 */
const HelpSection = ({ onClose, onChatWithSupport }: HelpSectionProps) => (
  <MenuList>
    <ListSubheader sx={{ lineHeight: 2.5 }}>Help</ListSubheader>
    <MenuItem
      component="a"
      href={HELP_CENTRE_URL}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClose}
    >
      <ListItemIcon>
        <HelpCentreIcon fontSize="small" />
      </ListItemIcon>
      <ListItemText>Help centre</ListItemText>
    </MenuItem>
    <MenuItem
      component="a"
      href={LOADED_ACADEMY_URL}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClose}
    >
      <ListItemIcon>
        <LoadedAcademyIcon fontSize="small" />
      </ListItemIcon>
      <ListItemText>Loaded Academy</ListItemText>
    </MenuItem>
    <MenuItem onClick={onChatWithSupport}>
      <ListItemIcon>
        <ChatWithSupportIcon fontSize="small" />
      </ListItemIcon>
      <ListItemText>Chat with support</ListItemText>
    </MenuItem>
    <MenuItem
      component="a"
      href={PRIVACY_POLICY_URL}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClose}
    >
      <ListItemIcon>
        <PrivacyPolicyIcon fontSize="small" />
      </ListItemIcon>
      <ListItemText>Privacy policy</ListItemText>
    </MenuItem>
    <MenuItem
      component="a"
      href={EULA_URL}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClose}
    >
      <ListItemIcon>
        <EulaIcon fontSize="small" />
      </ListItemIcon>
      <ListItemText>Terms of use</ListItemText>
    </MenuItem>
  </MenuList>
)

export default HelpSection
